import { Button, Typography } from '@mui/material';

import { useAuthentication } from '@/hooks/useAuthentication';
import { useTranslate } from '@/hooks/useTranslate';

import { FinishedLogo, StyledFinishedScreen } from './styles';

export default function ApplicationTypeSelectionFailedScreen() {
  const { t } = useTranslate();
  const { onBackToSignIn } = useAuthentication();
  return (
    <StyledFinishedScreen>
      <FinishedLogo />
      <Typography variant="h2" textAlign="center" mb={2}>
        {t('createNewAccount.thirdPartyComplianceCheckFailed.header')}
      </Typography>
      <Typography variant="body2" textAlign="center" mb={4}>
        {t('createNewAccount.applicationSelectionFailed.body')}
      </Typography>
      <Button fullWidth onClick={onBackToSignIn} variant="contained">
        {t(
          'createNewAccount.thirdPartyComplianceCheckFailed.button.backToLogin',
        )}
      </Button>
    </StyledFinishedScreen>
  );
}
